import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/formField/crmedical/custom/formField/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/formField/crmedical/custom/formField/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/formField/crmedical/custom/formField/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/formField/crmedical/custom/formField/submit', params,options)

export const update = (params, options) =>
request.post('/api/formField/crmedical/custom/formField/submit', params,options)
